// extracted by mini-css-extract-plugin
module.exports = {"viewToggleButton":"ViewToggleButton_viewToggleButton__ov4Zx","viewToggleButtonRight":"ViewToggleButton_viewToggleButtonRight__1m2fV ViewToggleButton_viewToggleButton__ov4Zx"};